import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';

export const TextWrapper = styled.span<{ $hasEndContent: boolean; }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  width: 100%;

  ${({ $hasEndContent }) => !$hasEndContent && css`
    display: contents;
  `}
`;

export enum TextStyle {
  BOLD,
  REGULAR,
}

interface LabelTextProps {
  $textStyle?: TextStyle;
}

export const LabelText = styled.span<LabelTextProps>`
  display: flex;
  align-items: center;
  gap: 6px;

  ${({ $textStyle }) => $textStyle === TextStyle.BOLD && TYPOGRAPHY.CIRCULAR.bold}
  ${({ $textStyle }) => $textStyle === TextStyle.REGULAR && TYPOGRAPHY.OPEN_SANS.base}
  color: ${BRAND_COLORS.black};
  font-size: 14px;
  line-height: 21px;
`;

export const Subtext = styled.span`
  ${TYPOGRAPHY.CIRCULAR.bold}
  color: ${BRAND_COLORS.darkStroke};
  font-size: 14px;
  line-height: 21px;
`;
